import type { PropsWithChildren, ReactNode } from 'react'

import LaunchIcon from '@mui/icons-material/Launch'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

export { PageSection }

type Props = PropsWithChildren<{
  id: string
  heading?: string
  headingLink?: {
    href: string
    hint: string
  }
  subheading?: string
  actions?: ReactNode
}>

const PageSection = ({
  id,
  heading,
  headingLink,
  subheading,
  actions,
  children,
}: Props) => {
  return (
    <Box id={id}>
      <Box sx={{ marginBottom: 3 }}>
        {(heading || subheading) && (
          <Box
            sx={{
              display: 'flex',
              gap: 1,
            }}
          >
            {heading && (
              <Typography
                variant="h2"
                sx={{
                  margin: 0,
                  alignItems: 'center',
                  display: 'flex',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  paddingLeft: 2,
                }}
              >
                <Box
                  sx={{
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {heading}
                </Box>

                {headingLink && (
                  <Tooltip title={headingLink.hint}>
                    <LaunchIcon
                      sx={{ cursor: 'pointer', marginLeft: 1, flexShrink: 0 }}
                      onClick={() => window.open(headingLink.href, '_blank')}
                    />
                  </Tooltip>
                )}
              </Typography>
            )}

            <Box sx={{ display: 'flex', flexGrow: 1, flexShrink: 0 }}>
              {actions}
            </Box>
          </Box>
        )}

        {subheading && (
          <Typography variant="h4" sx={{ marginTop: 1, paddingLeft: 2 }}>
            {subheading}
          </Typography>
        )}
      </Box>

      {children}
    </Box>
  )
}
